// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UqNHkXAxaDnD3noq8cwl {
  background-color: #F5F5F5;
  min-height: calc(100vh - 52px);
  padding: 20px;
}
.V60D4FrFbjuhJZnChkQX {
  width: 100%;
  background-color: #fff;
  padding: 20px auto;
}
.I_DFW5Ym3M6b0799fALm {
  padding: 10px 20px;
  border: 1px solid #eee;
}
.Olx3F8rALnSP1j6rdZMD {
  display: grid;
  grid-template-columns: repeat(auto-fill, 320px);
  gap: 16px;
  justify-content: center;
  /* 或 start */
  max-width: 1400px;
  margin: 0 auto;
  padding-top: 20px;
  padding-bottom: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Project/Workspace/index.module.less"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,8BAAA;EACA,aAAA;AACF;AAEA;EACE,WAAA;EACA,sBAAA;EACA,kBAAA;AAAF;AAGA;EACE,kBAAA;EACA,sBAAA;AADF;AAIA;EACE,aAAA;EACA,+CAAA;EACA,SAAA;EACA,uBAAA;EAFA,YAAY;EAGZ,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,oBAAA;AADF","sourcesContent":[".container {\n  background-color: #F5F5F5;\n  min-height: calc(100vh - 52px);\n  padding: 20px;\n}\n\n.cardContainer {\n  width: 100%;\n  background-color: #fff;\n  padding: 20px auto;\n}\n\n.cardHeader {\n  padding: 10px 20px;\n  border: 1px solid #eee;\n}\n\n.cardBody {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, 320px);\n  gap: 16px;\n  justify-content: center; /* 或 start */\n  max-width: 1400px;\n  margin: 0 auto;\n  padding-top: 20px;\n  padding-bottom: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `UqNHkXAxaDnD3noq8cwl`,
	"cardContainer": `V60D4FrFbjuhJZnChkQX`,
	"cardHeader": `I_DFW5Ym3M6b0799fALm`,
	"cardBody": `Olx3F8rALnSP1j6rdZMD`
};
export default ___CSS_LOADER_EXPORT___;
